import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Problems } from './components/Problems';
import { MeetSystem } from './components/MeetSystem';
import { Categories } from './components/Categories';
import { UseItYourWay } from './components/UseItYourWay';
import { MadeFor } from './components/MadeFor';
import { FromScattered } from './components/FromScattered';
import { InsideCarousel } from './components/InsideCarousel';
import { Bonuses } from './components/Bonuses';
import { LearningExperience } from './components/LearningExperience';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Comparison } from './components/Comparison';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-white font-body text-navy" data-id="element-0" data-mp="3mk84asujy1aw">
      <MetaPixel data-id="element-1" data-mp="3rcj8i7wbs999" />
      <TopBar data-id="element-2" data-mp="3rbznujfaj6rj" />
      <main data-id="element-3" data-mp="3rdkie91luppe">
        <Hero data-id="element-4" data-mp="3rcsulke91w9o" />
        <Stats data-id="element-5" data-mp="3recdlirailf5" />
        <Problems data-id="element-6" data-mp="5yj0slx59ec" />
        <MeetSystem data-id="element-7" data-mp="6hp9c27i9cj" />
        <Categories data-id="element-8" data-mp="4ww9qvjiygs" />
        <UseItYourWay data-id="element-9" data-mp="56nfhsbnbo2" />
        <MadeFor data-id="element-10" data-mp="7st1bvnjh3n" />
        <FromScattered data-id="element-11" data-mp="2zld2jatxbhc2" />
        <InsideCarousel data-id="element-12" data-mp="2zm4yimrfnh2v" />
        <Bonuses data-id="element-13" data-mp="2zmo7vf30ox5a" />
        <LearningExperience data-id="element-14" data-mp="2zn66ujh2dpgw" />
        <Pricing data-id="element-15" data-mp="33mf6g4yschkd" />
        <Testimonials data-id="element-16" data-mp="33lx18iu5at0b" />
        <Guarantee data-id="element-17" data-mp="33n6y54p9hv5d" />
        <Faq data-id="element-18" data-mp="33orki71fa7s5" />
        <Comparison data-id="element-19" data-mp="38lrnua6w0wfk" />
        <FinalCta data-id="element-20" data-mp="38l8gtoirzsgb" />
      </main>
      <Footer data-id="element-21" data-mp="38l017ov9q91f" />
      <PurchasePopup data-id="element-22" data-mp="38kgmeh0x00rm" />
    </div>;
}